export default __webpack_public_path__ + "static/exp3-5430d638f250e93a36bfb900c6a8a483.png";